import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SnapshotSharedVariablesService } from 'src/app/modules/snapshot/Services/snapshot-shared-variables.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { LoaderService } from '../../services/loader.service';
import { forkJoin, map, Observable } from 'rxjs';

@Component({
  selector: 'app-header-nav-snap-output',
  templateUrl: './header-nav-snap-output.component.html',
  styleUrls: ['./header-nav-snap-output.component.css']
})
export class HeaderNavSnapOutputComponent {
  @Input() isAddClientDetails: boolean = false;
  @Input() snapNameNavHeader:string="";
  @Input() ImageURL: string = '';

  @Output() defaultPanelChange = new EventEmitter<boolean>();
  clientSnapDetails: any;
  // @Input() AcrossDropdown : any;
  snapshotListData: any;
  selected_Snap: string = "";
  AcrossDropdown  :any
  snapshotType_name: any = "";
  constructor(private router: Router, private _loaderService: LoaderService,public _configService: SnapshotService, private clientDetails: SnapshotSharedVariablesService) {
    this.ImageURL = '';
   }
   ngOnInit(): void {
    this.clientSnapDetails = this.clientDetails.clientDetails;
    this.snapshotListData = this._configService.SnapshotList;
    this.snapshotType_name = sessionStorage.getItem('snapshotType');

    this.selected_Snap = this.clientSnapDetails.study;
    if(localStorage.getItem("AcrossDropdown")){
      let value = localStorage.getItem("AcrossDropdown");
      this.AcrossDropdown = value;
      this.AcrossDropdown = JSON.parse(this.AcrossDropdown);

      const sortOrder = ['Single Brand', 'Multiple Brands', 'Multiple Markets','Audience Snapshot'];
      this.AcrossDropdown.sort((a: any, b: any) => {
      return sortOrder.indexOf(a.snapshotType_name) - sortOrder.indexOf(b.snapshotType_name);
    });
    }
    if(this._configService.snapshotTypeSelectedName){
      this._configService.snapshotTypeSelectedName =  this.snapshotType_name;
    }
  }

  showSnapshotDropdownVal: boolean = false;
  showSnapshotDropdown() {
    this.showSnapshotDropdownVal = !this.showSnapshotDropdownVal;
  }

  // navigateSnapshot(selectedSnap: string) {
  //   this._loaderService.showLoader();
  //   this._configService
  //     .getClientStudyData({
  //       client_code: this.clientSnapDetails.client_code,
  //       snapshot_name: selectedSnap,
  //     })
  //     .subscribe(async (b) => {
  //       var x = JSON.parse(b.body.Data);
  //       if (
  //         x != null &&
  //         x != undefined &&
  //         x != ''
  //       ) {
  //         let mainStudy = x.study_list[0].study_name;
  //         // let data: { client_code: string; study: string } = {
  //         //   client_code: this.selectedClientCode,
  //         //   study: this.selectedStudy,
  //         // };

  //         let data: { client_code: string; study: string; main_study: string, snapList: any, snapshotselected: string, sectionselected: any; subsectionselected: any } = {
  //           client_code: this.clientSnapDetails.client_code,
  //           study: selectedSnap,
  //           main_study: mainStudy,
  //           snapList: this._configService.SnapshotList,
  //           snapshotselected: this._configService.snapshotSelectedName,
  //           sectionselected: this._configService.selectedSection,
  //           subsectionselected: this._configService.selectedSubSection
  //         };

  //         if (x.product == "Standard") {
  //           this.router.navigateByUrl('Snapshot/snapshot-output', { state: data });
  //         }
  //         else if (x.product == "Custom") {
  //           //this.router.navigate(['Snapshot', 'custom-snapshot-output'], { state: data });
  //           //this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
  //           this.router.navigateByUrl('/Snapshot', { skipLocationChange: true }).then(() => {
  //             this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data});
  //           });
  //         //   this.router.navigateByUrl('dummy').then(() => {
  //         //     this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
  //         // });
  //         }

  //       }
  //       else {
  //         this.router.navigateByUrl('landing');
  //       }
  //     })


  // }

  // @HostListener('document:click', ['$event'])
  // clickout(event: any) {
  //   if (event.target.id !== 'snapshot-dropdown' && event.target.id !== 'snapshot-text') {
  //     this.showSnapshotDropdownVal = false;
  //   }
  // }

  navigateSnapshot(item:any, section:any,  subsection:any) {
    const oldSectionName = this._configService.selectedSection;
    const oldSubSectionName = this._configService.selectedSubSection;
    let snapshotType = sessionStorage.getItem('snapshotType');
    // After a save-selection load, sessionStorage can still hold the previous
    // type while selectedcompareacrossOption already reflects the loaded one.
    // Require both to match before treating this as a same-type switch.
    const activeSnapshotType =
      this._configService.selectedcompareacrossOption ||
      this._configService.selectedSnapshotType ||
      snapshotType;
    sessionStorage.setItem('sectionName', section.section_name);
    let subSection = subsection.subsection_name ? subsection.subsection_name : "NA";
    sessionStorage.setItem('subsectionName', subSection);
    
    this.clientDetails.clientDetails.sectionselected = section.section_name;
    this.clientDetails.clientDetails.subsectionselected = subsection.subsection_name;
    this.clientSnapDetails.sectionselected = section.section_name;
    this.clientSnapDetails.subsectionselected = subsection.subsection_name;
    this._configService.selectedSection = section.section_name;
    this._configService.selectedSubSection = subsection.subsection_name;
    this.snapshotType_name = item.snapshotType_name;
    this._configService.snapshotTypeSelectedName = item.snapshotType_name;
    
    if(
      snapshotType == item.snapshotType_name &&
      activeSnapshotType == item.snapshotType_name
    ) {
      this.resolveFomAction(
        oldSectionName,
        oldSubSectionName ? oldSubSectionName : "NA",
        section.section_name,
        subsection.subsection_name ? subsection.subsection_name : "NA"
      ).subscribe((action) => {
        if (action === 'apply') {
          // Neither old nor new section has a separate FOM -> just reapply
          // the existing selection, do NOT reload the left panel.
          this._configService.tiggerSelectionSnapshotType = false;
          this._configService.isFomChanged = false;
          this._configService.reapplySelectionAfterReload = false;
          this._configService.isSameSnapshotType.next(true);
          this.defaultPanelChange.emit(true);
        } else if (action === 'reloadPick') {
          // A selected variable was removed from the new section's FOM ->
          // reload the left panel and let the user pick a fresh selection.
          this._configService.tiggerSelectionSnapshotType = true;
          this._configService.isFomChanged = true;
          this._configService.reapplySelectionAfterReload = false;
          sessionStorage.removeItem('dataLoaded');
          this.proceedWithNavigation(item);
        } else {
          // reloadApply: FOM differs but the selection is still valid ->
          // reload the left panel (correct entry points for new section) and
          // auto-apply the same selection, then auto-submit to output.
          this._configService.tiggerSelectionSnapshotType = false;
          this._configService.isFomChanged = false;
          this._configService.reapplySelectionAfterReload = true;
          sessionStorage.removeItem('dataLoaded');
          this.proceedWithNavigation(item);
        }
      });
    }
    else{
      // Different snapshot type (existing logic)
      // Drop leftover save-selection / previous-type submit state so the new
      // snapshot type (e.g. Multiple Brands) does not reuse Single Brand data.
      this._configService.finalLeftPanelSubmitObject = null;
      this._configService.finalLeftPanelInputSelectedObject = null;
      this._configService.dataObjectForSaveSelection = null;
      this._configService.saveSelectionLoad = false;
      this._configService.tiggerSelectionSnapshotType = true;
      this._configService.isFomChanged = false;
      this._configService.reapplySelectionAfterReload = false; // reset while navigating
      sessionStorage.removeItem('dataLoaded');
      sessionStorage.setItem('snapshotType', item.snapshotType_name);
      this._configService.selectedcompareacrossOption = item.snapshotType_name;
      this._configService.selectedSnapshotType = item.snapshotType_name;
      this._configService.isSameSnapshotType.next(false);
      this.proceedWithNavigation(item);
    }
  }

  /**
   * Decides how a same-type section/subsection switch (A -> B) should behave:
   *  - 'apply'      : neither A nor B has a separate FOM -> reapply selection, no reload
   *  - 'reloadPick' : a separate FOM exists AND a selected var was removed from B -> reload, user picks
   *  - 'reloadApply': a separate FOM exists but selection still valid -> reload + auto-apply selection
  */
  resolveFomAction(
    oldSectionName: string,
    oldSubSectionName: string,
    newSectionName: string,
    newSubSectionName: string
  ): Observable<'apply' | 'reloadPick' | 'reloadApply'> {
    const client_name = this.clientDetails.clientDetails.client_code;
    const study_name = this.clientDetails.clientDetails.main_study;
    const snapshot_name = this.clientDetails.clientDetails.study;
    const snapshot_type = sessionStorage.getItem('snapshotType');

    const oldFomPayload = {
      client_name, study_name, snapshot_name, snapshot_type,
      section_name: oldSectionName,
      subsection_name: oldSubSectionName === "NA" ? '' : oldSubSectionName,
      includeData: true
    };
    const newFomPayload = {
      client_name, study_name, snapshot_name, snapshot_type,
      section_name: newSectionName,
      subsection_name: newSubSectionName === "NA" ? '' : newSubSectionName,
      includeData: true
    };

    return forkJoin({
      oldFom: this._configService.checkSeparateFomExists(oldFomPayload),
      newFom: this._configService.checkSeparateFomExists(newFomPayload)
    }).pipe(
      map(({ oldFom, newFom }) => {
        const aHasFom = !!oldFom?.exists;
        const bHasFom = !!newFom?.exists;

        if (!aHasFom && !bHasFom) {
          return 'apply';
        }
        // Either side has a separate FOM -> panel must reload.
        return this.hasRemovedSelectedVariable(newFom) ? 'reloadPick' : 'reloadApply';
      })
    );
  }

  private proceedWithNavigation(item: any) {
    this._loaderService.showLoader();
    this._configService
      .getClientStudyData({
        client_code: this.clientSnapDetails.client_code,
        snapshot_name: this.clientSnapDetails.study
      })
      .subscribe(async (b) => {
        var x = JSON.parse(b.body.Data);
        if (
          x != null &&
          x != undefined &&
          x != ''
        ) {
          let mainStudy = x.study_list[0].study_name;

          if (x?.saveselection) {
            this._configService.globalDefaultSelectionFlag = x.saveselection.find(
              (item: { key: string; value: boolean }) => item.key === "Global Default Selection"
            )?.value ?? false;
          }
          let data: { client_code: string; study: string; main_study: string, snapList: any, snapshotselected: string, sectionselected: any; subsectionselected: any, isAcrossdropDown: boolean } = {
            client_code: this.clientSnapDetails.client_code,
            study: this.clientSnapDetails.study,
            main_study: mainStudy,
            snapList: this._configService.SnapshotList,
            snapshotselected: item.snapshotType_name,
            sectionselected: item.section[0].section_name,
            subsectionselected: item.section[0].subsection[0].subsection_name,
            isAcrossdropDown: true
          };

          if (x.product == "Standard") {
            this.router.navigateByUrl('Snapshot/snapshot-output', { state: data });
          }
          else if (x.product == "Custom") {
            this.router.navigateByUrl('/Snapshot', { skipLocationChange: true }).then(() => {
              this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
            });
          }
        }
        else {
          this.router.navigateByUrl('landing');
        }
      })
  }

  /**
   * Returns true if at least one currently-selected variable appears in the
   * new FOM's variables_removed_from_fom list.
   */
  private hasRemovedSelectedVariable(fom: any): boolean {
    const removedRows: any[] = fom?.data?.variables_removed_from_fom ?? [];
    if (removedRows.length === 0) {
      return false; // nothing removed -> selection stays valid
    }

    const previewData =
      this._configService.finalLeftPanelSubmitObject?.previewData ??
      this._configService.dataObjectForSaveSelection;
    if (!previewData) {
      return false; // no prior selection to invalidate
    }

    // Build the set of removed-variable keys from the FOM.
    const removedKeys = new Set<string>(
      removedRows.map((r) => this.fomRowKey(r))
    );

    // Walk every selection bucket and test each selected variable.
    const buckets = ['Row', 'Column', 'RowNesting', 'ColNesting', 'Filter'];
    for (const bucketName of buckets) {
      const bucket = previewData[bucketName];
      if (!Array.isArray(bucket)) continue;

      for (const group of bucket) {
        if (group.Parent === 'Total Sample') {
          continue;
        }

        const dataItems = group?.Data ?? [];
        for (const dataItem of dataItems) {
          if (removedKeys.has(this.selectionItemKey(dataItem))) {
            return true; // a selected variable was removed -> reload
          }
        }
      }
    }
    return false;
  }

  /** Key for a variable that was removed from the FOM. */
  private fomRowKey(r: any): string {
    const group = this.norm(r.metric_group_snapshot);
    if (group === 'brands') {
      return `brand:${this.norm(r.response_label)}`;
    }
    if (group === "time period") {
      return `tp:${this.norm(r.variable_label)}`;
    }
    return `var:${this.norm(r.data_variable_code)}|${this.norm(r.response_code)}`;
  }

  /** Key for a variable in the current left-panel selection (previewData). */
  private selectionItemKey(item: any): string {
    const variableCode = this.norm(item.variablecode);
    const responseCode = this.norm(item.responsecode);

    // For Time Period use variable label, because if Month is removed then all months would get removed, response code doesn't matter.
    if (item.isTimePeriod) {
      const child = (item.Child ?? '').split('|')[0] ?? '';
      return `tp:${this.norm(child)}`;
    }

    // Brands have no variable/response code; identify them by label.
    if (variableCode === '' && responseCode === '') {
      const child = (item.Child ?? '').split('|').pop() ?? '';
      return `brand:${this.norm(child)}`;
    }
    return `var:${variableCode}|${responseCode}`;
  }

  private norm(value: any): string {
    return (value ?? '').toString().trim().toLowerCase();
  }
}
